module.exports = __webpack_public_path__ + "img/category-sport.50267999.png";